const cat = `


              ██████           █████                    
             █ *****█         █**♪  ███                 
             █**♪♪♪**█████████* ♪♪♪***███               
            █☼************  *   **** ***███             
           █☼☼                          * █             
           █☼                           **█             
           █*    ♦♦♦♦♦♦       ♦♦♦♦♦      *█             
           █*    ♦♦¥¥♦♦       ♦♦¥¥♦      *█             
           ██*   ♦♦▲▲♦        ♦♦♦        *█       (cat)      
            █*                           *█             
            █*           ┌───┐           *█             
            █*           │♪♪♪│           *█             
            ██*          └───┘           *█             
             ██**                    ***███             
               ██******** ***********████               
                ██████████████ ███████                                                            

`
console.log(cat)


import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

import HomeApp from './components/HomeApp.vue'
import Login from './components/LoginApp.vue'
import Register from './components/RegisterApp.vue'
import MyPayments from "./components/MyPayments.vue"
import MySubscription from "./components/MySubscription.vue"
import EmailVerification from "./components/EmailVerification.vue"
import sucessPayement from './components/sucessPayement.vue'
import store from './store';
import { createI18n } from 'vue-i18n';
import xsintInformations from './components/xsintInformations.vue'
import aboutUs from './components/aboutUs.vue'
import giftApp from './components/giftApp.vue'
import terms from './components/termsApp.vue'
import axiosPlugin from './plugins/axios';
import { createHead } from '@vueuse/head';
import gtc from './components/a_ecgvapp.vue'
import xsintupdates from './components/ap__cupzzedates2.vue'
import xsintlookup from './components/lookup_em.vue'
import discord_con from './components/app_discord_sys.vue'
import forgot_password_vue from './components/forgot_password_vue.vue'
import reset_password_vue from './components/reset_password_vue.vue'
const head = createHead();
loadFonts()


const i18n = createI18n({
  locale: 'en',
  messages: {
    en: {
      welcome_homeapp: 'Welcome to XSINT !',
      //text2_hommeapp: "The best osint software 🥷",

      /*default_username_menubar: "Guest",
      home_page_name_menubar: "Home",
      informations_page_name_menubar: "Informations",
      pricing_page_name_menubar: "Pricing",
      register_page_name_menubar: "Register",
      login_page_name_menubar: "Login",

      register_link_logigapp: "Sign up now",

      register_button_registerapp: "Register",
      accept_termes_of_use_registerapp: "By clicking the \"Register\" button and creating an account, you agree to the site's terms of use",

      whatisxsint__toolsinformations: "What is XSINT?",
      xint_informations_toolsinformations: 'XSINT is an OSINT software that brings together various powerful tools to facilitate investigations. The most powerful tools are the "email lookup" tool and the "Database Engine". (You can click on the tool names to understand how they work). XSINT respects your privacy: no searches are logged or stored on our server, and we try not to use major software like Google Captcha... which are only software that spy on you and retain your data.',
    
      buy_button_productsapp: "Buy",

      howfound__emaillookupinformations: "How XSINT Email Lookup Works ?",*/
    },
    de: {
      welcome_homeapp: 'Welcome to XSINT 🇩🇪',
      //text2_hommeapp: "Die beste OSINT-Software 🥷",

      //default_username_menubar: "Gast 🇩🇪",
      /*home_page_name_menubar: "Homepage",
      informations_page_name_menubar: "Informationen",
      pricing_page_name_menubar: "Preise",
      register_page_name_menubar: "Registrieren",
      login_page_name_menubar: "Anmelden",

      register_link_logigapp: "Jetzt anmelden",

      register_button_registerapp: "Registrieren",
      accept_termes_of_use_registerapp: 'Durch Klicken auf die Schaltfläche "Registrieren" und das Erstellen eines Kontos stimmst du den Nutzungsbedingungen der Website zu.',

      whatisxsint__toolsinformations: "Was ist XSINT?",
      xint_informations_toolsinformations: 'XSINT ist eine OSINT-Software, die verschiedene leistungsfähige Tools zusammenführt, um Untersuchungen einfacher durchzuführen. Die leistungsfähigsten Tools sind das "Email Lookup"-Tool und der "Database Engine". (Sie können auf die Namen der Tools klicken, um zu verstehen, wie sie funktionieren). XSINT respektiert Ihre Privatsphäre: Keine Suchen werden in den Logs oder auf unserem Server gespeichert, und wir versuchen, keine großen Software wie Google Captcha... zu verwenden, die nur Software sind, die Sie ausspioniert und Ihre Daten speichert.',

      buy_button_productsapp: "Kaufen",
      howfound__emaillookupinformations: "Wie funktioniert XSINT Email Lookup ?",*/
    },
    fr: {
      welcome_homeapp: 'Welcome to XSINT 🇫🇷',
      //text2_hommeapp: "Le meilleur logiciel d'osint 🥷",

      /*default_username_menubar: "Invité 🇫🇷",
      home_page_name_menubar: "Accueil",
      informations_page_name_menubar: "Informations",
      pricing_page_name_menubar: "Tarifs",
      register_page_name_menubar: "Inscription",
      login_page_name_menubar: "Connexion",

      register_link_logigapp: "Inscrivez-vous maintenant",

      register_button_registerapp: "S'inscrire",
      accept_termes_of_use_registerapp: 'En cliquant sur le bouton "S\'inscrire" et en créant un compte, vous acceptez les conditions d\'utilisation du site.',

      whatisxsint__toolsinformations: " Qu'est-ce que XSINT?",
      xint_informations_toolsinformations: 'XSINT est un logiciel d\'OSINT regroupant différents outils puissants pour faciliter les enquêtes. Les outils les plus puissants sont l\'outil "email lookup" et le "Database Engine". (Vous pouvez cliquer sur les noms des outils pour comprendre leur fonctionnement). XSINT respecte votre vie privée : aucune recherche n\'est enregistrée dans les journaux ni sur notre serveur, et nous essayons de ne pas utiliser de gros logiciels comme Google Captcha... qui ne sont que des logiciels vous espionnant et conservant vos données.',
    
      buy_button_productsapp: "Acheter",

      howfound__emaillookupinformations: "Comment fonctionne XSINT Email Lookup ?",*/
    },
    it: {
      welcome_homeapp: 'Welcome to XSINT  🇮🇹',
      //text2_hommeapp: "Il miglior software osint 🥷",
      
      /*default_username_menubar: "Ospite 🇮🇹",
      home_page_name_menubar: "Home",
      informations_page_name_menubar: "Informazioni",
      pricing_page_name_menubar: "Prezzi",
      register_page_name_menubar: "Registrati",
      login_page_name_menubar: "Accedi",

      register_link_logigapp: "Iscriviti ora",

      register_button_registerapp: "Registrati",
      accept_termes_of_use_registerapp: 'Cliccando sul pulsante "Registrati" e creando un account, accetti i termini d\'uso del sito.',

      whatisxsint__toolsinformations: "Cos'è XSINT?",
      xint_informations_toolsinformations: 'XSINT è un software di OSINT che raggruppa vari strumenti potenti per facilitare le indagini. Gli strumenti più potenti sono lo strumento "email lookup" e il "Database Engine". (Puoi cliccare sui nomi degli strumenti per capire come funzionano). XSINT rispetta la tua privacy: nessuna ricerca viene registrata nei log né sul nostro server e cerchiamo di non utilizzare software grandi come Google Captcha... che sono solo software che ti spiano e conservano i tuoi dati.',
      
      buy_button_productsapp: "Acquista",
      howfound__emaillookupinformations: "Come funziona XSINT Email Lookup ?",*/
    },
    es: {
      welcome_homeapp: 'Welcome to XSINT 🇪🇸',
      //text2_hommeapp: "El mejor software osint 🥷",

      /*default_username_menubar: "Invitado 🇪🇸",
      home_page_name_menubar: "Inicio",
      informations_page_name_menubar: "Informaciones",
      pricing_page_name_menubar: "Precios",
      register_page_name_menubar: "Registro",
      login_page_name_menubar: "Iniciar sesión",

      register_link_logigapp: "Regístrate ahora",

      register_button_registerapp: "Inscribirse",
      accept_termes_of_use_registerapp: 'Al hacer clic en el botón "Registrarse" y crear una cuenta, aceptas los términos de uso del sitio.',

      whatisxsint__toolsinformations: "¿Qué es XSINT?",
      xint_informations_toolsinformations: 'XSINT es un software de OSINT que reúne varias herramientas poderosas para facilitar las investigaciones. Las herramientas más potentes son la herramienta de "búsqueda de correos electrónicos" y el "Motor de Base de Datos". (Puede hacer clic en los nombres de las herramientas para entender cómo funcionan). XSINT respeta su privacidad: ninguna búsqueda se registra en los registros ni en nuestro servidor, y tratamos de no utilizar grandes software como Google Captcha... que son solo software que lo espían y retienen sus datos.',
    
      buy_button_productsapp: "Comprar",

      "howfound__emaillookupinformations": "¿Cómo funciona la búsqueda de correo electrónico XSINT?",*/
    },
  }
});

try{
  let language = navigator.language || navigator.userLanguage
  if (language) {
    i18n.global.locale = language;
  }
} catch{
  console.log('traduction error')
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', component: HomeApp },
    {path: '/discord-bot', component: discord_con},
    {path: '/lookup', component: xsintlookup},
    {path: '/updates', component: xsintupdates},
    { path: '/terms', component: terms },
    { path: '/gift', component: giftApp },
    { path: '/email-verification', component: EmailVerification },
    { path: '/sucess-payment', component: sucessPayement},
    { path: '/email-search', component: xsintlookup},
    { path: '/phone-search', component: xsintlookup},
    { path: '/database-engine', component: xsintlookup},
    { path: '/mypayments', component: MyPayments},
    { path: '/mysubscription', component: MySubscription},
    { path: '/register', component: Register},
    { path: '/login', component: Login},
    { path: '/features', component: xsintInformations},
    { path: '/about-us', component: aboutUs},
    { path: '/gtc', component: gtc},
    { path: '/forgot-password', component: forgot_password_vue},
    { path: '/reset-password', component: reset_password_vue}

  ]
})

const options = {
  position: POSITION.TOP_RIGHT,
};

createApp(App)
  .use(vuetify)
  .use(Toast, options)
  .use(store)
  .use(i18n)
  .use(axiosPlugin)
  .use(router)
  .use(head)
  .mount('#app')


